<template>
  <div style="padding: 2rem; background: #fff">
    <vxe-toolbar
      v-if="
        operateType === 'add' ||
        operateType === 'edit' ||
        operateType === 'renewal' ||
        operateType === 'changeInfo' ||
        operateType === 'changeSubject'
      "
    >
      <template v-slot:buttons>
        <vxe-button type="primary" class="vxe-btn-primary" @click="insertEvent">新增</vxe-button>
        <vxe-button
          type="primary"
          class="vxe-btn-delete"
          @click="handleDelete('waterCostTable')"
          :style="'background-color:' + '#FE8783' + ';border:1px solid ' + '#FE8783'"
          >删除</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      width="100%"
      align="left"
      show-header-overflow
      class="vxe-table-element"
      show-footer
      :auto-resize="true"
      border
      resizable
      show-overflow
      :data="waterCostTableDate"
      :edit-config="editConfig"
      size="mini"
      ref="waterCostTable"
      :max-height="$store.state.app.tableHeight"
      :edit-rules="waterCostTableEditRules"
      :key="tableKey"
    >
      <vxe-table-column type="checkbox" width="60"></vxe-table-column>
      <vxe-table-column
        field="rowIndex"
        title="行号"
        width="120"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.rowIndex"
            @change="(val) => handleRowIndexChange(val, scope.row, scope)"
          >
            <el-option
              v-for="(item, index) in spaceTableData"
              :key="index"
              :label="item.rowIndex"
              :value="item.rowIndex"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{ row.lineNo || row.currentIndex }}</template>
      </vxe-table-column>
      <!-- <vxe-table-column
        field="spaceAreaNo"
        title="片区"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.spaceAreaNo"
            clearable
            filterable
            @change="() => handleAreaChange(scope.row, scope, 'waterCostTable')"
          >
            <el-option
              v-for="(item, index) in areaList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.spaceAreaNo, areaList, 'id', 'name')
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="spaceAssetNo"
        title="资产名称"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.spaceAssetNo"
            clearable
            filterable
            @change="() => handleAssetsChange(scope.row, scope, 'waterCostTable')"
          >
            <el-option
              v-for="(item, index) in scope.row.assetsList || []"
              :key="index"
              :label="item.name"
              :value="item.id"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.spaceAssetNo, row.assetsList, 'id', 'name')
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="spaceUnitNo"
        title="单元（楼栋）"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.spaceUnitNo"
            clearable
            filterable
            @change="() => handleUnitChange(scope.row, scope, 'waterCostTable')"
          >
            <el-option
              v-for="(item, index) in scope.row.unitList || []"
              :key="index"
              :label="item.name"
              :value="item.id"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.spaceUnitNo, row.unitList || [], 'id', 'name')
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="spaceFloorNo"
        title="楼层"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.spaceFloorNo"
            clearable
            filterable
            @change="() => handleFloorChange(scope.row, scope, 'waterCostTable')"
          >
            <el-option
              v-for="(item, index) in scope.row.spaceFloorList || []"
              :key="index"
              :label="item.name"
              :value="item.id"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.spaceFloorNo, row.spaceFloorList, 'id', 'name')
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="spaceRoomNo"
        title="房号"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.spaceRoomNo"
            clearable
            filterable
            @change="() => handleRoomChange(scope.row)"
          >
            <el-option
              v-for="(item, index) in scope?.row?.roomList || []"
              :key="index"
              :label="item.name"
              :value="item.id"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.spaceRoomNo, row?.roomList || [], 'id', 'name')
        }}</template>
      </vxe-table-column> -->
      <vxe-table-column
        field="expenseType"
        title="费用类型"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.expenseType"
            clearable
            filterable
            @change="() => changeExpenseType(scope.row, 'expenseType')"
          >
            <el-option
              v-for="(item, index) in hydropowerList"
              :key="index"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{ transferSelect(row.expenseType, hydropowerList) }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="energyId"
        title="水/电表编号"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.energyId"
            clearable
            filterable
            @change="handleEnergyCode(scope, scope.row, scope.row.energyCodeList)"
          >
            <el-option
              v-for="(item, index) in scope.row.energyCodeList"
              :key="index"
              :label="item.energyCode"
              :value="item.energyId"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          row.energyCodeList?.find((item) => item.energyId == row.energyId)?.energyCode
        }}</template>
      </vxe-table-column>
      <!-- row.energyCodeList?.find((item)=>item.energyId==row.energyId)?.energyCode -->
      <!-- transferSelect(row.energyId, row.energyCodeList, 'energyId', 'energyCode') -->
      <!-- <vxe-table-column field="energyCategoryName" title="类型">
        <template v-slot:edit="scope">
          <el-input v-model="scope.row.energyCategoryName" />
        </template>
        <template v-slot="{ row }">{{ transferSelect(row.energyCategory, categoryList) }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="expenseType"
        title="费用类型"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.expenseType"
            clearable
            filterable
            @change="() => checkUniqueRow(scope.row, 'expenseType')"
          >
            <el-option
              v-for="(item, index) in hydropowerList"
              :key="index"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{ transferSelect(row.expenseType, hydropowerList) }}</template>
      </vxe-table-column> -->
      <vxe-table-column
        field="chargePrice"
        title="计费单价（元）"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <input-number
            :max="'9999999.9999'"
            v-model="scope.row.chargePrice"
            :precision="4"
            @input="(val) => handleChargePrice(val, scope.row, scope)"
          ></input-number>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="chargeMethod"
        title="计费方式"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.chargeMethod"
            clearable
            filterable
            @change="() => checkUniqueRow(scope.row, 'chargeMethod')"
          >
            <el-option
              v-for="(item, index) in waterChargeMethodList"
              :key="index"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.chargeMethod, waterChargeMethodList)
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="measurementUnit"
        title="计量单位"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select v-model="scope.row.measurementUnit" clearable filterable>
            <el-option
              v-for="(item, index) in waterProductUnitList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.measurementUnit, waterProductUnitList)
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="chargeCycle"
        title="计费周期"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select v-model="scope.row.chargeCycle" clearable filterable>
            <el-option
              v-for="(item, index) in chargeCycleList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{ transferSelect(row.chargeCycle, chargeCycleList) }}</template>
      </vxe-table-column>
      <!-- <vxe-table-column
        field="annualGrowthRate"
        title="年增长比例"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <input-number
            :max="'999.99'"
            v-model="scope.row.annualGrowthRate"
            :precision="'2'"
          ></input-number>
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column
        field="firstSettlementDate"
        title="首次结算日期"
        width="150"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-date-picker
            v-model="scope.row.firstSettlementDate"
            value-format="yyyy-MM-dd"
            type="date"
            style="width: 120px"
            placeholder=""
          >
          </el-date-picker>
        </template>
      </vxe-table-column> -->
      <vxe-table-column field="remark" title="备注" :edit-render="{ type: 'default' }">
        <template v-slot:edit="scope">
          <el-input v-model="scope.row.remark" maxlength="20" />
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
  import leaseContractMixin from '@/pages/property/leaseContract/mixins/leaseContract';
  import {
    hydropowerList,
    waterChargeMethodList,
    waterProductUnitList,
    chargeCycleList,
    categoryList,
  } from '../data';
  import API from '@/api/property/leaseContract';
  // import costInfoVue from '../../../wareHouse/costAdjustOrder/components/costInfo.vue';
  export default {
    name: 'waterCost',
    props: [
      'leaseDateFrom',
      'leaseDateUntil',
      'detailWaterCostTableData',
      'waterSpaceIds',
      'deleteSpaceId',
      'isClearWater',
      'spaceTableData',
      'contractCategory',
      'contractInfoData',
    ],
    mixins: [leaseContractMixin],
    computed: {
      operateType() {
        return this.$route.query.type;
      },
      // pickerSettleOptions() {
      //   return {
      //     disabledDate: (time) => {
      //       return time < new Date(this.startDate) - 8.64e7 || time > new Date(this.endDate);
      //     },
      //   };
      // },
      waterCostTableEditRules() {
        return {
          energyId: [
            {
              required: true,
              message: '请选择',
              trigger: 'blur',
            },
          ],
          // spaceAssetNo: [
          //   {
          //     required: true,
          //     message: '请选择',
          //     trigger: 'blur',
          //   },
          // ],
          // spaceUnitNo: [
          //   {
          //     required: true,
          //     message: '请选择',
          //     trigger: 'blur',
          //   },
          // ],
          // spaceFloorNo: [
          //   {
          //     required: true,
          //     message: '请选择',
          //     trigger: 'blur',
          //   },
          // ],
          // spaceRoomNo: [
          //   {
          //     required: true,
          //     message: '请选择',
          //     trigger: 'blur',
          //   },
          // ],
          expenseType: [
            {
              required: true,
              message: '请选择',
              trigger: 'blur',
            },
          ],
          chargePrice: [
            {
              required: true,
              message: '请填写',
              trigger: 'blur',
            },
          ],
          chargeMethod: [
            {
              required: true,
              message: '请选择',
              trigger: 'blur',
            },
          ],
          measurementUnit: [
            {
              required: true,
              message: '请选择',
              trigger: 'blur',
            },
          ],
          chargeCycle: [
            {
              required: true,
              message: '请选择',
              trigger: 'blur',
            },
          ],
          // annualGrowthRate: [
          //   {
          //     required: true,
          //     message: '请选择',
          //     trigger: 'blur',
          //   },
          // ],
          // firstSettlementDate: [
          //   {
          //     required: true,
          //     message: '请选择',
          //     trigger: 'blur',
          //   },
          // ],
        };
      },
    },
    data() {
      return {
        waterCostTableDate: [],
        editConfig: {},
        hydropowerList,
        waterChargeMethodList,
        waterProductUnitList,
        chargeCycleList,
        categoryList,
        energyCodeList: [],
        waterEnergyCodeList: [],
        electricEnergyCodeList: [],
        detailWaterSpaceIds: [],
        activeCollapses: ['1'],
        isPropertyContract: true,
        tableKey: new Date().getTime(),
        tempData: '',
      };
    },
    watch: {
      contractCategory(val) {
        console.log('====', val);
        if (val == '02') {
          //物业合同
          this.isPropertyContract = false;
        }
        if (val == '01') {
          this.isPropertyContract = true;
        }
        console.log('isPropertyContract监听', this.isPropertyContract);
      },
      detailWaterCostTableData(newVal) {
        if (newVal) {
          this.dealDetailData(newVal);
        }
        this.operateType === 'changeSubject' ? { trigger: 'dblclick', mode: 'row' } : {};
        // this.getEnergyType();
      },
      waterCostTableDate(val) {
        val.forEach((item) => {
          this.getEnergy(item);
        });
        this.waterCostTableDate = val;
        console.log('监听水表数据', this.waterCostTableDate);
      },
      deleteSpaceId: {
        handler(newVal) {
          if (newVal && Array.isArray(newVal) && newVal.length) {
            this.deleteSpaceRowsHandler(newVal);
          }
        },
        deep: true,
        immediate: true,
      },
      // isClearWater: {
      //   handler(val) {
      //     if (val) {
      //       this.waterCostTableDate = [];
      //     }
      //   },
      //   deep: true,
      //   immediate: true,
      // },
    },
    // created() {
    //   this.getEnergy();
    // },
    mounted() {
      this.editConfig =
        this.operateType === 'add' ||
        this.operateType === 'edit' ||
        this.operateType === 'renewal' ||
        this.operateType === 'changeInfo' ||
        this.operateType === 'changeSubject'
          ? { trigger: 'dblclick', mode: 'row' }
          : {};
    },
    methods: {
      handleRowIndexChange(val, row, scope) {
        console.log(val, row, scope, '---->>');
        const currentItem = this.spaceTableData.find((item) => item.rowIndex == val);
        console.log(JSON.stringify(currentItem), '选中的');
        row['spaceId'] = currentItem.spaceId;
        row['currentIndex'] = val;
        console.log('行号', row['spaceId']);
      },
      // 删除空间行信息的时候
      deleteSpaceRowsHandler(spaceIdList) {
        // 过滤row.spaceId 在spaceIdList中的数据
        console.log(this, '111');
        const tableDataList = this.$refs.waterCostTable.getTableData().fullData;
        console.log(tableDataList, '表格数据', this.waterCostTableDate, spaceIdList);
        this.waterCostTableDate = tableDataList.filter(
          (item) => !spaceIdList.includes(item.spaceId)
        );
      },
      handleChargePrice(val, row, scope) {
        console.log(val, row, scope);
      },
      checkUniqueRow(row, filedName) {
        const tableDataList = this.$refs.waterCostTable.getTableData().fullData;
        console.log(tableDataList, '====>表格数据', row, filedName);
      },
      async dealDetailData(list) {
        // for (let item of list) {
        //   if (item.spaceAreaNo) {
        //     await this.getAssetsList(item);
        //   }
        //   if (item.spaceAssetNo) {
        //     await this.getUnitList(item);
        //   }
        //   if (item.spaceUnitNo) {
        //     await this.getSpaceFloorList(item);
        //   }
        //   if (item.spaceFloorNo) {
        //     await this.getRoomList(item);
        //   }
        // }
        console.log(this.spaceTableData, '---你好-->>>');
        this.waterCostTableDate = list.map((item, index) => {
          return {
            ...item,
            rowIndex: index + 1, // 需要判断当前空间信息是否有
          };
        });
        // if (this.operateType !== 'add') {
        //   this.dealTypeData();
        // }
      },
      async insertEvent() {
        if (this.isPropertyContract) {
          console.log(this.$parent, 'insertEvent');
          const spaceList = this.spaceTableData;
          console.log(spaceList, '--->>');
          if (spaceList.length === 0) {
            this.$message({
              showClose: true,
              message: '请填写空间信息',
              type: 'error',
            });
            // await this.getEnergy(spaceIds);
          }
        }

        this.$refs['waterCostTable'].validate((valid) => {
          if (valid) {
            let record = {
              // spaceAreaNo: '',
              // spaceAssetNo: '',
              // spaceUnitNo: '',
              // spaceFloorNo: '',
              // spaceRoomNo: '',
              // energyCode: '',
              energyType: '',
              energyId: '',
              energyCategory: '',
              energyCategoryName: '',
              expenseType: '',
              chargePrice: '',
              chargeMethod: '',
              measurementUnit: '',
              chargeCycle: '',
              // annualGrowthRate: '',
              // firstSettlementDate: '',
              remark: '',
            };
            this.$refs.waterCostTable
              .insert(record, -1)
              .then(({ row }) => this.$refs.waterCostTable.setActiveRow(row));
          }
        });
      },

      async getEnergy(row) {
        console.log(this.contractInfoData, '????', row);
        const params = {
          spaceId: row['spaceId'], //租赁合同传,物业合同不用传
          energyType: ['01', '04'].includes(row['expenseType']) ? '01' : '02', //都需要传 01-水表,02-电表   01和04是水费,02和03是电费
          contractCategory: this.contractInfoData.contractCategory, //(合同类型) 都需要传
          companyCode: this.userInfo.companyCode, //(当前登陆人的公司code) 物业合同需要传
        };
        // if (row['spaceId']) {
        //   delete params.spaceId;
        // }
        await this.$axios.post(API.WATER_ENERGY, params).then((res) => {
          console.log(res, '12234');
          if (res.data.code === 0) {
            row.energyCodeList = res.data.data || [];
          }
        });

        console.log(JSON.stringify(row.energyCodeList));
        // this.tableKey = new Date().getTime()
      },
      handleEnergyCode(scope, row, energyCodeList) {
        console.log(row, '处理水电表');
        // row.energyCategoryName = '';
        // row.energyCategory = '';
        let energyList = energyCodeList;
        const result = energyList.filter((item) => item.energyId === row.energyId);
        console.log('result', result);
        const resultObj = result[0] || {};
        console.log(resultObj, '2222');
        row.energyCode = resultObj.energyCode;
        // row.energyType = resultObj.energyType;
        console.log(row.energyCode, row.energyId);
        // console.log("处理水表前空间Id",row['spaceId'])
        // 记录当前的空间id,方便删除
        // row['spaceId'] = this.energyCodeList.find(
        //   (item) => item.energyId == row['energyId']
        // )?.space?.id;
        // console.log("处理水表后空间Id",row['spaceId'])
        // if (resultObj.energyType === '01') {
        //   row.energyCategory = resultObj.category;
        //   row.energyCategoryName = resultObj.category === '01' ? '冷水' : '热水';
        // }
        this.$refs.waterCostTable.reloadRow(row);
        this.$refs.waterCostTable.updateStatus(scope);
      },

      async changeExpenseType(row, filedName) {
        row['energyCode'] = null;
        row['energyId'] = null;
        console.log(row, filedName, row.spaceId, '切换费用类型');
        await this.getEnergy(row);
        // row.energyCodeList = row.energyCodeList;
        console.log('水电表信息', row.energyCodeList);
        // this.tableKey = new Date().getTime()
        this.waterCostTableDate = this.$refs.waterCostTable.getTableData().fullData;
        this.tempData = row;
        this.tableKey = new Date().getTime();
        // await this.$refs.waterCostTable.setActiveRow(row)
      },
    },
    updated() {
      this.$refs.waterCostTable.setActiveRow(this.tempData);
    },
  };
</script>

<style lang="scss" scoped>
  .title {
    font-size: 20px;
    font-weight: 600;
  }
</style>
